import { create } from "zustand";
import { uuIdv4 } from "@/forApp/utils/uuIdv4";

export type ModalT = {
	name: string;
} & Record<string, any>;

export type NotificationT = {
	text: string;
	type: "error" | "success" | "warning";
	id?: string;
};

type AppState = {
	modals: ModalT[];
	addModal: (modal: ModalT) => void;
	delModal: () => void;
	notifications: NotificationT[];
	addNotification: (notification: NotificationT) => void;
	deleteNotification: () => void;
	deleteNotificationId: (id: string) => void;
	filters: Record<string, string[] | string>;
	setFilters: (key: string, value: string[] | string) => void;
	cleanFilters: () => void;
	breadcrumbs: [];
	isMobile: boolean;
	toggleIsMobile: (isMobile: boolean) => void;
	isOpenMobileMenu: boolean;
	toggleIsOpenMobileMenu: (isOpenMobileMenu: boolean) => void;
	isLoading: boolean;
	setIsLoading: (isLoading: boolean) => void;
};

export const useApp = create<AppState>()((set) => ({
	isLoading: false,
	setIsLoading: (isLoading: boolean) => {
		return set((state) => {
			return {
				...state,
				isLoading,
			};
		});
	},
	isMobile: false,
	toggleIsMobile: (isMobile) => {
		set((state) => {
			return { ...state, isMobile };
		});
	},
	isOpenMobileMenu: false,
	toggleIsOpenMobileMenu: (isOpenMobileMenu) => {
		set((state) => {
			return { ...state, isOpenMobileMenu };
		});
	},
	breadcrumbs: [],
	modals: [],
	addModal: (modal: ModalT) => {
		set((state) => {
			return { ...state, modals: [modal, ...state.modals] };
		});
	},
	delModal: () => {
		set((state) => {
			if (state.modals.length) {
				const updatedModals = state.modals.slice(1);
				return { ...state, modals: updatedModals };
			} else {
				return state;
			}
		});
	},
	notifications: [],
	addNotification: (notification) => {
		set((state) => {
			return {
				...state,
				notifications: [
					...state.notifications,
					{ ...notification, id: uuIdv4() },
				],
			};
		});
	},
	deleteNotification: () => {
		set((state) => {
			const updatedNotifications = [...state.notifications];
			updatedNotifications.pop();
			return { ...state, notifications: updatedNotifications };
		});
	},
	deleteNotificationId: (id: string) => {
		set((state) => {
			return {
				...state,
				notifications: state.notifications.filter((notification) =>
					id ? notification.id !== id : false,
				),
			};
		});
	},
	filters: {
		["filters[ad_type]"]: "sale",
		type: "apartments",
	},
	setFilters: (key: string, value: string[] | string) => {
		set((state) => {
			const newFilters = {
				...state.filters,
				[key]: value,
			};

			return {
				...state,
				filters: newFilters,
			};
		});
	},
	cleanFilters: () => {
		set((state) => {
			return {
				...state,
				filters: {
					["filters[ad_type]"]: state.filters["filters[ad_type]"],
					type: state.filters.type,
				},
			};
		});
	},
}));
